import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ZtButtonConfig, ZtButtonType } from './zt-button.model';

@Component({
    selector: 'zt-button',
    templateUrl: 'zt-button.component.html',
    styleUrls: ['zt-button.component.scss'],
})
export class ZtButtonComponent implements OnInit {
    @Input() config: ZtButtonConfig | undefined;
    @Input() type: ZtButtonType | undefined;
    @Input() rounded: boolean  = false;
    @Input() disabled: boolean = false;
    @Input() loading: boolean = false;

    @Output() onClick: EventEmitter<void> = new EventEmitter<void>();

    ngOnInit() {}

    onClickListener() {
        this.onClick.emit();
    }
}
